import { ProductMediaMapUtil } from '@xengage/gw-portals-util-js';

export default {
    // Platform ProductMediaMapUtil functions
    getProductCodeIcon: ProductMediaMapUtil.getProductCodeIcon,
    getLOBIcon: ProductMediaMapUtil.getLOBIcon,
    getPolicyTypeIcons: ProductMediaMapUtil.getPolicyTypeIcons,
    getProductCodeImage: ProductMediaMapUtil.getProductCodeImage
};
